import { Firm } from '../../components/firms/firm/mapper'
import { FirmCareerSite } from '../../types/firm/careerSite'

export function careerSiteInfos<T extends Firm>({
  hasCareerSite,
  colorCareerSite,
  careerSite,
}: T): FirmCareerSite | undefined {
  if (hasCareerSite || careerSite?.hasCareerSite) {
    return {
      hasCareerSite: true,
      colorCareerSite: careerSite?.colorCareerSite || colorCareerSite || '',
      templateName: careerSite?.templateName || 'V1',
    }
  }
  return undefined
}
